export * from './card';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/card/index.js
// module id = 635
// module chunks = 3